import { activityListSaga } from './activityList';

export const activitySaga = [
    ...activityListSaga,
];
